/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrderLabelRequest
 */
export interface CreateOrderLabelRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateOrderLabelRequest
     */
    orderId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderLabelRequest
     */
    text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderLabelRequest
     */
    color?: string | null;
}

/**
 * Check if a given object implements the CreateOrderLabelRequest interface.
 */
export function instanceOfCreateOrderLabelRequest(value: object): value is CreateOrderLabelRequest {
    if (!('orderId' in value) || value['orderId'] === undefined) return false;
    return true;
}

export function CreateOrderLabelRequestFromJSON(json: any): CreateOrderLabelRequest {
    return CreateOrderLabelRequestFromJSONTyped(json, false);
}

export function CreateOrderLabelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrderLabelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'],
        'text': json['text'] == null ? undefined : json['text'],
        'color': json['color'] == null ? undefined : json['color'],
    };
}

export function CreateOrderLabelRequestToJSON(json: any): CreateOrderLabelRequest {
    return CreateOrderLabelRequestToJSONTyped(json, false);
}

export function CreateOrderLabelRequestToJSONTyped(value?: CreateOrderLabelRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'text': value['text'],
        'color': value['color'],
    };
}

